export const partogramFillingLogsSentences = {
	examiner_id: "Examinador",
	datetime: "Hora",
	dilation: "Dilatação/cm",
	delee_plan: "Plano DeLee",
	heart_rate: "BFC - Batimentos/Min",
	contractions_per_second: "Contrações/seg",
	amniotic_sac: "Bolsa",
	amniotic_fluid: "Líquido Amniótico",
	medication_taken: "Medicação",
	product_id: "Medicação Selecionada",
	systolic_blood_pressure: "Pressão Arterial Sistólica",
	diastolic_blood_pressure: "Pressão Arterial Diastólica",
	pulse: "Pulso",
	observations: "Observações",
	temperature: "Temperatura",
};
